export default __webpack_public_path__ + "static/media/640_store04-nl-mobile.26c38941.png";